import { BRANCH_TYPE, EIV_ENTRY_TYPE } from 'global/constants';

import { doesRegisteredInstallerHaveBranch } from 'utils/InstallerUtils';

const mapEntryTypeToEiv = (entryType) => {
  if (entryType === 'main') {
    return EIV_ENTRY_TYPE.MAIN;
  }
  if (entryType === 'guest') {
    return EIV_ENTRY_TYPE.GUEST;
  }
  return null;
};

export const getDebFIBranchSelectionValues = (installerStatusSummary) => ({
  isEnergyActive: doesRegisteredInstallerHaveBranch(BRANCH_TYPE.ENERGY, installerStatusSummary),
  isGasActive: doesRegisteredInstallerHaveBranch(BRANCH_TYPE.GAS, installerStatusSummary),
  branchTypeEnergy: mapEntryTypeToEiv(installerStatusSummary[BRANCH_TYPE.ENERGY]?.entryType),
  branchTypeGas: mapEntryTypeToEiv(installerStatusSummary[BRANCH_TYPE.GAS]?.entryType),
});
